var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/_shared-key.js
 ** module id = 42
 ** module chunks = 0
 **/